import api from "./api";
import type { TrendListOut, StagesSummary, LifecycleStage } from "@/types";

export const trendKeys = {
  list: (stage?: LifecycleStage | null, category?: string | null, sort?: "score" | "surge" | null) =>
    ["trends", stage, category, sort] as const,
  stages: (category?: string | null) => ["trends", "stages", category] as const,
  categories: () => ["trends", "categories"] as const,
  detail: (id: number) => ["trend", id] as const,
};

export async function fetchTrends(
  stage?: LifecycleStage | null,
  category?: string | null,
  sort?: "score" | "surge" | null,
): Promise<TrendListOut> {
  const params: Record<string, string> = {};
  if (stage) params.stage = stage;
  if (category) params.category = category;
  if (sort) params.sort = sort;
  const { data } = await api.get<TrendListOut>("/trends", { params });
  return data;
}

export async function fetchStages(category?: string | null): Promise<StagesSummary> {
  const params: Record<string, string> = {};
  if (category) params.category = category;
  const { data } = await api.get<StagesSummary>("/trends/stages", { params });
  return data;
}

export interface CategoriesSummary {
  date: string;
  is_fallback: boolean;
  total: number;
  tagged: number;
  categories: Record<string, number>;
}

export async function fetchCategories(): Promise<CategoriesSummary> {
  const { data } = await api.get<CategoriesSummary>("/trends/categories");
  return data;
}

export interface RecipeListItem {
  id: number;
  keyword_id: number;
  keyword: string;
  title: string;
  youtube_url: string;
  channel_name: string | null;
  view_count: number | null;
  difficulty: string | null;
  lifecycle_stage: string | null;
  categories: string[];
}

export const recipeKeys = {
  list: (
    sort: string,
    category?: string | null,
    limit?: number,
    stage?: string | null,
    perKeyword?: number,
  ) => ["recipes", "list", sort, category, limit, stage, perKeyword] as const,
};

export async function fetchRecipesList(
  sort: "view" | "recent" = "view",
  category?: string | null,
  limit = 30,
  stage?: string | null,    // β-9 rolling 라이프사이클 (emerging/growing/mature/declining)
  perKeyword?: number,      // stage 모드 시 키워드당 cap (1=홈 다양성, 5=목록 기본)
): Promise<RecipeListItem[]> {
  const params: Record<string, string | number> = { sort, limit };
  if (category) params.category = category;
  if (stage) params.stage = stage;
  if (perKeyword !== undefined) params.per_keyword = perKeyword;
  const { data } = await api.get<RecipeListItem[]>("/recipes/list", { params });
  return data;
}
